import React from "react";

import { Title, Label } from "shared/components";
import {
  StyledFieldsetProps,
  StyledFieldset,
  GridChildren,
  FlexChildren,
  StyledSeparator,
  StyledTitle,
} from "./styles";
import { StyledLabel } from "../Label/styles";

export interface FieldsetProps extends StyledFieldsetProps {
  title?: string;
  label?: string | JSX.Element;
  separator?: string | JSX.Element;
}

export const Fieldset: React.FC<FieldsetProps> = ({
  title,
  label,
  hideContainer,
  style,
  separator,
  children,
}) => {
  return (
    <StyledFieldset hideContainer={hideContainer} style={style}>
      {title && (
        <StyledTitle>
          <Title title={title} asComponent="legend" size="s" />
        </StyledTitle>
      )}
      {label && (
        <StyledLabel as="span">
          <Label>{label}</Label>
        </StyledLabel>
      )}
      {children && (
        <React.Fragment>
          {separator ? (
            <FlexChildren>
              {(children as JSX.Element[]).map((child: JSX.Element, index: number) => (
                <React.Fragment key={index}>
                  {index !== 0 && <StyledSeparator>{separator}</StyledSeparator>}
                  {child}
                </React.Fragment>
              ))}
            </FlexChildren>
          ) : (
            <GridChildren style={style}>{children}</GridChildren>
          )}
        </React.Fragment>
      )}
    </StyledFieldset>
  );
};
